import { render, staticRenderFns } from "./SummaryStatementComponent.vue?vue&type=template&id=ab4590f0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SummaryStatementComponent.vue?vue&type=script&lang=js&"
export * from "./SummaryStatementComponent.vue?vue&type=script&lang=js&"
import style0 from "./SummaryStatementComponent.vue?vue&type=style&index=0&id=ab4590f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4590f0",
  null
  
)

component.options.__file = "SummaryStatementComponent.vue"
export default component.exports